module.exports = false;



//////////////////
// WEBPACK FOOTER
// D:/Projects/GitHub/gvrogers/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0